import { Fragment, Slice } from '@atlaskit/editor-prosemirror/model';

import type {
	RemoveNodeCommand,
	StreamingCommandFactory,
} from '../aiStreamingOrchestratorPluginType';

import { findNodeByLocalId } from './utils/find-node-by-local-id';

export const createRemoveNodeCommand: StreamingCommandFactory<RemoveNodeCommand> =
	(api) => (command) => {
		return api.core.actions.execute(({ tr }) => {
			return findNodeByLocalId(api, tr, command.localId, ({ node, pos }) => {
				api.aiExperience.actions.tagAsAIStreamingTransformation(tr, { isFinal: true });

				// Record a coarse "remove" segment so the Post Stream
				// Review modal can review / undo / redo this deletion. removeNode is
				// non-streamable: it mutates the doc directly here and never reaches
				// `buildCommitTransaction`, so we must record the segment ourselves.
				// The removed node becomes `originalUserContentSlice`; the segment
				// collapses to a zero-width range at the deletion point (`newSlice`
				// is empty). `recordAIContentSegments` is a no-op when the New AIFC
				// experience is OFF.
				const removedSlice = new Slice(Fragment.from(node), 0, 0);
				tr.delete(pos, pos + node.nodeSize).scrollIntoView();
				// Map the original position through the delete step to get the
				// collapsed (zero-width) position at the deletion point.
				const collapsedPos = tr.mapping.map(pos);
				api.aiExperience.actions.recordAIContentSegments(tr, [
					{
						startPos: collapsedPos,
						endPos: collapsedPos,
						originalUserContentSlice: removedSlice,
						newSlice: Slice.empty,
						kind: 'remove',
					},
				]);
			});
		});
	};
